import { environment } from '../../../environments/environment';
import { billingCustomer, withCustomer } from './customer-context';
// Rebillers (30 Oct 2026): a customer selected in My Account opens in Billing too (?customer=, checked again by Billing and OneGate).
// SPEC-4 (2 Nov 2026): under a rebiller's voice view Billing opens on the rebiller's own account unless a customer is passed (Monthly).
export function billingSsoUrl(path='/invoices', customer?: string|null):string {
  path=withCustomer(path,customer===undefined?billingCustomer():customer);
  const configured=(environment as any).billingPortalUrl;
  const origin=configured || ((environment as any).envName==='production'?'https://billing.ringoffice.com':'https://billing-dev.ringoffice.com');
  const callback=new URL('/auth/sso/callback',origin);callback.searchParams.set('next',path);
  const audience=(environment as any).billingPortalAudience || ((environment as any).envName==='dev'?'billing-portal-porta':'billing-portal');
  return '/sso?portal='+encodeURIComponent(audience)+'&return='+encodeURIComponent(callback.toString());
}
